// The generated SDK throws `ApiException` on any non-2xx response, whose
// `message` is a multi-line debug dump (HTTP-Code / Message / Body / Headers) —
// never fit to surface to a user. The server's actual message lives in
// `body.error` (the `ModelError` shape). This pulls it out, falling back to a
// caller-supplied friendly message when no server message is available.
export const getApiErrorMessage = (
  error: unknown,
  fallback: string
): string => {
  if (typeof error === 'object' && error !== null && 'body' in error) {
    const body = error.body;
    if (typeof body === 'object' && body !== null && 'error' in body) {
      const message = body.error;
      if (typeof message === 'string' && message.length > 0) {
        return message;
      }
    }
  }
  return fallback;
};
